import { Link } from 'react-router-dom'
import { useAppSelector } from '../store/hooks'
import './ContainerTable.css'

const ACTIVE_STATUSES = ['pending', 'starting', 'started', 'idle', 'processing']

function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const minutes = Math.floor(diff / 60000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

function statusClass(status: string): string {
  if (ACTIVE_STATUSES.includes(status)) return 'container-table__status--active'
  if (status === 'failed') return 'container-table__status--failed'
  return 'container-table__status--stopped'
}

function ContainerTable() {
  const containers = useAppSelector((state) => state.status.recentContainers)
  const activeCount = containers.filter((c) => ACTIVE_STATUSES.includes(c.status)).length

  return (
    <section className="container-table" aria-labelledby="container-table-heading">
      <div className="container-table__header">
        <h2 className="container-table__title" id="container-table-heading">All Containers</h2>
        <span className="container-table__counts">
          <span className="container-table__count-active">{activeCount} active</span>
          <span className="container-table__count-sep">/</span>
          <span className="container-table__count-total">{containers.length} total</span>
        </span>
      </div>
      {containers.length === 0 ? (
        <div className="container-table__empty">No containers</div>
      ) : (
        <div className="container-table__scroll">
          <table className="container-table__table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Container</th>
                <th>App</th>
                <th>Last Activity</th>
              </tr>
            </thead>
            <tbody>
              {containers.map((c) => (
                <tr key={c.container_id} className={ACTIVE_STATUSES.includes(c.status) ? 'container-table__row--active' : ''}>
                  <td>
                    <span className={`container-table__status ${statusClass(c.status)}`}>
                      {c.status}
                    </span>
                  </td>
                  <td className="container-table__id">{c.container_id}</td>
                  <td>
                    {c.app_id ? (
                      <Link to={`/apps/${c.app_id}`} className="container-table__app-link">
                        {c.app_name || c.app_id}
                      </Link>
                    ) : (
                      <span className="container-table__no-app">-</span>
                    )}
                  </td>
                  <td className="container-table__time">
                    {c.last_event_at ? formatRelativeTime(c.last_event_at) : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}

export default ContainerTable
